import { ChangeEvent, useRef, useState } from "react";
import HeaderBar from "../../Components/HeaderBar";
import Sidebar from "../../Components/SideBar";
import * as XLSX from "xlsx";
import { saveAs } from 'file-saver';
import Swal from 'sweetalert2';
import axios from "axios";
import { useSelector } from "react-redux";
import LoaderSpinner from "../../Components/LoaderSpinner";

const urlApiBase = process.env.REACT_APP_apiUrl;

const UpdateCases = () =>{

  const Body = () =>{

    const emp:any = useSelector((state: any) => state.emp);
    const [swtShow, setSwtShow] = useState(false);
    let [dataExcel, setDataExcel] = useState<any>([]);  
    let [dataArr, setDataArr] = useState<any>([]);   
    let [show, setShow] = useState(false);            
    const formRef = useRef<HTMLFormElement | null>(null);

    const data = [
      { IdInvgate: '', NroCaso: ''}
    ];

    const exportToExcel = (data: any) => {
      // Crear un libro de trabajo y una hoja
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(data);
  
      // Agregar la hoja al libro de trabajo
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  
      // Generar un archivo Excel en formato binario
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  
      // Crear un archivo Blob y descargarlo
      const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });
      saveAs(dataBlob, 'Formato.xlsx');
    };

    const readExcel = (file: any) => {

      const promise = new Promise((resolve, reject) => {
        
        const fileReader = new FileReader();
        fileReader.readAsArrayBuffer(file);
  
        fileReader.onload = (e: any) => {
          const bufferArray = e.target.result;
          const wb = XLSX.read(bufferArray, { type: "buffer" });
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          const data = XLSX.utils.sheet_to_json(ws);
          resolve(data);
        };
  
        fileReader.onerror = (error) => {
          reject(error);
        };
  
      });
  
      promise.then((d: any) => {
          setDataExcel([...d]);
          console.log("Excel : ", d);
      });
    };

    const cargarFile = (flname: any) =>{

      if (flname){
        readExcel(flname)
      }else{
        Swal.fire({
          title: '¡Advertencia!',
          text: 'No se ha seleccionado archivo!!!',
          icon: "info",
          iconColor: "orange",
          confirmButtonText: 'Aceptar',
          confirmButtonColor: 'green',
        });        
      }
    }

    const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
      if (e.target.files && (e.target.files.length > 0)){         
        const file = e.target.files[0];
        cargarFile(file);
      }else{
        setDataExcel([]);
        setSwtShow(false);
      }
    }

    const handleProccess = () =>{

      if (dataExcel.length > 0){
        setShow(true);
        dataExcel.map((item: any)=>{
          dataArr.push(item.IdCaso);
        });
        console.log("Excel proccess: ", dataExcel, dataArr);
        // Realizar la solicitud PUT
        const headers = {
          headers: {
            'Authorization': `Bearer ${emp.token}`,
            'Content-Type': 'application/json',
          },
        };
        axios.post(`${urlApiBase}/api/Casos/Uncheck`, dataArr, headers)
        .then((response: any) => {
          dataExcel = response.data.jsonObject;
          setDataExcel([...dataExcel]);
          Swal.fire({
            title: '',
            text: 'Archivo procesado con éxito!!!',
            icon: "info",
            iconColor: "green",
            confirmButtonText: 'Aceptar',
            confirmButtonColor: 'green',
          });   
          setShow(false);         
        })
        .catch(error => {
            Swal.fire({
              title: '¡Advertencia!',
              text: `Se ha presentado un error al intentar procesar la información. Contacte al administrador.`,
              icon: "error",
              iconColor: "red",
              confirmButtonText: 'Aceptar',
              confirmButtonColor: 'red',
            });
        });
        if ((formRef !== null) && (formRef !== undefined)){
          formRef?.current?.reset(); 
        }

        setDataArr([]);        
      }else{
        Swal.fire({
          title: '¡Advertencia!',
          text: 'No hay archivo para procesar. Seleccione uno con los codigos a procesar.',
          icon: "info",
          iconColor: "orange",
          confirmButtonText: 'Aceptar',
          confirmButtonColor: 'green',
        });
      }
    }

    //componente tabla q lista el contenido del archivo de excel subido
    const Tabla = (props: {data: any}) => {

      return(
        <div className="table-responsive border rounded p-3" style={{height: "485px"}}>
          <table className="table table-success table-striped border rounded" >
            <thead>
              <tr>
                <th>ID Invgate</th>                
                <th>Nro. Caso</th>
                <th>Estado</th>
                <th>Mensaje</th>                  
              </tr>
            </thead>
            <tbody>
              {props.data.map((item: any, index : number) => (
                <tr key={index}>
                  <td>{item.IdInvgate}</td>                  
                  <td>{item.NroCaso}</td>
                  <td>{(item.Actualizado !== undefined) && (item.Actualizado ? "Exitoso": "No exitoso")}</td>
                  <td>{item.Mensaje}</td>                    
                </tr>
              ))}
            </tbody>
          </table>
      </div>
      );
    };

    return(
        <>
            <div className="container text-success m-3">
                <label className="h3">Actualización casos de afiliación</label>
            </div>
      
            <div className="row gap-1 m-3 p-2 border rounded shadow">

                <div className="col-lg-12 mb-3">
                    <div className="row  text-success ">              
                        <div className="col-lg-12">
                            <button type="button" onClick={()=>exportToExcel(data)} className="btn btn-outline-success w-100 gap-1 d-flex align-items-center justify-content-center">
                                <i className="fs-2 bi-cloud-download "></i>    
                                <label htmlFor="formFileLg" className="form-label h5 text-success mx-3">Descargue aquí la plantilla</label>                                   
                            </button>                        
                        </div>
                    </div>
                </div>           

                <hr />

                <div className="col-lg-12">
                  <label htmlFor="formFileLg" className="form-label h4 text-success p-2">Cargue plantilla diligenciada</label>
                  <form id="miForm" ref={formRef} >
                    <input className="form-control" type="file"  onChange={handleFileChange} accept="application/xlsx, .xlsx, .csv" />                    
                  </form>
                </div>

                <div className=" col-lg-12">
                  <div className="form-check form-switch my-3 h4 text-success">
                    <input className="form-check-input bg-success" type="checkbox" id="flexSwitchCheckChecked" onChange={()=>{
                      setSwtShow(!swtShow);
                    }} checked={swtShow}/>
                    <label className="form-check-label" htmlFor="flexSwitchCheckChecked">Mostrar datos</label>
                  </div>                    
                </div>

                <div className="col-lg-12">
                      <div className="d-flex justify-content-end">
                          <button type="button"  onClick={handleProccess}  className="btn btn-success d-flex  align-items-center gap-2">
                              <i className="fs-6 bi-list-columns-reverse"></i> 
                              <span className="">Procesar</span>
                          </button>                        
                      </div>
                </div>
                {
                  swtShow && <Tabla data={dataExcel}/>
                }
            </div>
            <LoaderSpinner
                  color="#0fc26f"
                  Show={show}
                  text="Procesando..."
              />  
        </>
    );
  }

    return(
        <>
            <div className=" m-3 border rounded shadow">
                <div>
                    <HeaderBar />          
                </div>
                <div className="d-flex">
                    <div className="" style={{width: "20%"}}>
                        <Sidebar />            
                    </div>
                    <div className="" style={{width: "80%"}}>
                        <Body/>            
                    </div>
                </div>
            </div>
        </>
    );
};

export default UpdateCases;